<template>
  <div class="profile-page">
    <h1>个人中心</h1>
    <div class="profile-avatar">
      <img
        v-if="avatarUrl"
        :src="avatarUrl"
        alt="用户头像"
        class="avatar"
      />
      <div v-else class="default-avatar">
        {{ initials }}
      </div>
    </div>
    <div class="profile-actions">
      <el-button @click="openPasswordDialog" class="change-password-btn">修改密码</el-button>
      <el-button type="danger" @click="logout" class="logout-btn">
        <i class="el-icon-switch-button logout-icon"></i>
        <span class="logout-text">退出登录</span>
      </el-button>
    </div>
    <password-dialog v-model="showPasswordDialog" />
  </div>
</template>

<script>
import PasswordDialog from '@/components/PasswordDialog';

export default {
  components: {
    PasswordDialog
  },
  data() {
    return {
      showPasswordDialog: false
    };
  },
  computed: {
    avatarUrl() {
      return  require('@/assets/default-avatar.png');
    },
    initials() {
      const name = this.$store.state.user.name || '用户';
      return name.substr(0, 1).toUpperCase();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    openPasswordDialog() {
      this.showPasswordDialog = true;
    }
  }
};
</script>

<style scoped>
.profile-page {
  flex: 1;
  padding-bottom: 60px;
}

.profile-page h1 {
  margin-top: 2rem;
  text-align: center;
}

.profile-page .profile-avatar {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.profile-page .avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.profile-page .default-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #3498db;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  border: 2px solid #fff;
}

.profile-page .profile-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
}

.profile-page .profile-actions button {
  padding: 12px 24px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.profile-page .profile-actions button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.4);
}

.profile-page .profile-actions .logout-btn {
  background: rgba(231, 76, 60, 0.9);
  color: white;
  border: none;
}

.profile-page .profile-actions .change-password-btn {
  background: #3498db;
  color: white;
  border: none;
}
.el-button+.el-button {
  margin: 0px;
}
</style>
